import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { navigationService } from '@/utils/navigationService';

interface NavigationProviderProps {
  children: React.ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize the navigation service with React Router's navigate function
    navigationService.setNavigate(navigate);
    
    // Cleanup function to clear the navigate function when component unmounts
    return () => {
      navigationService.setNavigate(() => {
        console.warn('Navigation service has been cleaned up');
      });
    };
  }, [navigate]);

  return <>{children}</>;
};